<div
  class="lounge-card"
  [ngClass]="policyClass"
  role="button"
  tabindex="0"
  [attr.aria-label]="selectLabel + ' ' + card.name"
  [attr.aria-disabled]="card.unavailable ? true : null"
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()"
  (keydown.space)="onCardClick()"
>
  @if (policyLabel) {
    <span class="visuallyhidden">{{ policyLabel }}</span>
  }
  <div class="lounge-card__body">
    <div class="lounge-card__main">
      <div class="lounge-card__name">{{ displayName }}</div>

      @if (card.terminal) {
        <div class="lounge-card__terminal">
          <fa-icon [icon]="faLocationDot" class="lounge-card__pin"></fa-icon>
          <span><span i18n="@@chatLoungeTerminal">Terminal</span> {{ card.terminal }}</span>
        </div>
      }

      <div class="lounge-card__flights">
        <span class="lounge-card__flight-type" [class.is-no]="!card.isSuitableForDomestic">
          <span class="lounge-card__flight-icon">{{ card.isSuitableForDomestic ? '✓' : '✗' }}</span>
          <span i18n="@@chatLoungeDomestic">Domestic flights</span>
        </span>
        <span class="lounge-card__flight-type" [class.is-no]="!card.isSuitableForInternational">
          <span class="lounge-card__flight-icon">{{
            card.isSuitableForInternational ? '✓' : '✗'
          }}</span>
          <span i18n="@@chatLoungeInternational">International flights</span>
        </span>
      </div>

      <div class="lounge-card__meta">
        @if (card.isPreferred) {
          <span class="lounge-card__preferred" i18n="@@chatLoungePreferred">Preferred</span>
        }
      </div>
    </div>

    <div class="lounge-card__price-col">
      @if (!card.unavailable) {
        <span class="lounge-card__price">{{ formattedPrice }}</span>
        <span class="lounge-card__price-label" i18n="@@totalPrice"> Total Price </span>
      } @else {
        <span class="lounge-card__unavailable-label" i18n="@@chatLoungeUnavailableShort"
          >Unavailable</span
        >
      }
      <!-- Policy indicator: same component/tooltip as the results page,
           placed under the headline price per the travel-policy spec. -->
      <app-warning-tags
        [ticket]="headlineWarningTicket"
        [displayCheck]="false"
        (click)="$event.stopPropagation()"
      ></app-warning-tags>
    </div>
  </div>

  <!-- The component supplies its own top border, which is the horizontal rule
       QA asked for. Events are stopped so rating a card never selects it. -->
  <app-chat-card-feedback
    class="lounge-card__feedback"
    [feedbackId]="feedbackId"
    [summary]="feedbackSummary"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
  ></app-chat-card-feedback>
</div>
